import { getValueObjectByPath } from '@helpers'
import { EXPAND_FIELD_PREFIX } from '@constants'
import { GETObjectDataParamsEnriched, ObjectFieldDTO } from '@types'

export const getResolvedOptionId = (
  item: GETObjectDataParamsEnriched,
  objLinkField: ObjectFieldDTO | undefined,
  targetIdPath?: string
) => {
  const idByTargetPath = targetIdPath ? getValueObjectByPath(item, targetIdPath) : undefined
  const hasTargetIdValue =
    (typeof idByTargetPath === 'string' || typeof idByTargetPath === 'number') &&
    idByTargetPath !== ''

  if (hasTargetIdValue) {
    return idByTargetPath
  }

  const expandedTargetIdPath = (() => {
    if (!targetIdPath) return undefined

    const pathParts = targetIdPath.split('.').filter(Boolean)
    if (pathParts.length < 2) return undefined

    const displayField = pathParts[pathParts.length - 1]
    const refPathParts = pathParts.slice(0, -1)

    return [
      ...refPathParts.map(pathPart => `${EXPAND_FIELD_PREFIX}${pathPart}`),
      displayField,
    ].join('.')
  })()

  const idByExpandedTargetPath = expandedTargetIdPath
    ? getValueObjectByPath(item, expandedTargetIdPath)
    : undefined
  const hasIdByExpandedTargetPathValue =
    (typeof idByExpandedTargetPath === 'string' || typeof idByExpandedTargetPath === 'number') &&
    idByExpandedTargetPath !== ''

  if (hasIdByExpandedTargetPathValue) {
    return idByExpandedTargetPath
  }

  const idByObjLinkField = objLinkField ? item[objLinkField.name] : undefined
  const hasObjLinkFieldValue =
    (typeof idByObjLinkField === 'string' || typeof idByObjLinkField === 'number') &&
    idByObjLinkField !== ''

  return hasObjLinkFieldValue ? idByObjLinkField : ''
}
